import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import DateInputPicker2 from 'modules/common/components/DateInputPicker2';
import * as c from '../constant';
import * as actions from '../action';

function TaxCreditModal({
  addTaxCredit,
  // getNewBusinessesList,
  history,
  getSingleNewBusinesses,
  // ordinanceRevisionId,
  creating,
  id,
  type,
  updateTaxCredit,
  taxCreditData,
  businessId,
}) {
  const [formData, setFormData] = useState({
    amount: '',
    notes: '',
    tc_number: '',
    date: '',
  });

  const validateForm = useFormValidator(formData, {
    amount: 'required',
    notes: 'required',
    tc_number: 'required',
    date: 'required',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    const args = {
      ...formData,
      date: `${moment(_.get(formData, 'date')).format('MM/DD/YYYY')}`,
    };

    if (type === 'NEW') {
      return addTaxCredit(id, args, ({ data }) => {
        setModal({ isOpen: false });
        // getNewBusinessesList({ ordinance_revision_id: ordinanceRevisionId });
        history.push(`/bpls/new-business/new-businesses/${+_.get(data, 'id')}`);
        getSingleNewBusinesses(+data.id);
      });
    }

    return updateTaxCredit(businessId, args, ({ data }) => {
      setModal({ isOpen: false });
      // getNewBusinessesList({ ordinance_revision_id: ordinanceRevisionId });
      history.push(`/bpls/new-business/new-businesses/${+_.get(data, 'id')}`);
      getSingleNewBusinesses(+data.id);
    });
  };

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(','), formData]);

  const OnSetFormData = () => {
    setFormData({
      notes: _.get(taxCreditData, 'attributes.notes') || '',
      tc_number: _.get(taxCreditData, 'attributes.tc_number') || '',
      date: moment(_.get(taxCreditData, 'attributes.date')).format('MM/DD/YYYY') || '',
      amount: _.get(taxCreditData, 'attributes.amount') || 0,
    });
  };

  useEffect(() => {
    if (!_.isEmpty(taxCreditData)) {
      OnSetFormData();
    }
  }, []);

  const MAX_VAL = 999999999999;
  const withValueCap = inputObj => {
    const { value } = inputObj;
    if (value <= MAX_VAL) return true;
    return false;
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Tax Credit Number : {validateForm.renderMessage('tc_number')}
            </label>
            <input
              className="form-control"
              type="text"
              name="tc_number"
              min="3"
              max="50"
              onChange={onChange}
              value={_.get(formData, 'tc_number') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Amount : {validateForm.renderMessage('amount')}
            </label>
            <NumberFormat
              name="amount"
              id="amount"
              className="form-control"
              onValueChange={values => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  amount: floatValue || '',
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              isAllowed={withValueCap}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'amount', '')}` || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Date : {validateForm.renderMessage('date')}
            </label>
            <DateInputPicker2
              required
              className="full-input"
              onChange={handleOnChangeDate('date')}
              value={_.get(formData, 'date')}
              maxDate={new Date()}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Notes : {validateForm.renderMessage('notes')}
            </label>
            <input
              className="form-control"
              type="text"
              min="3"
              name="notes"
              onChange={onChange}
              value={_.get(formData, 'notes') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
TaxCreditModal.defaultProps = {
  type: '',
  taxCreditData: {},
  businessId: '',
  // ordinanceRevisionId: '',
};

TaxCreditModal.propTypes = {
  // getNewBusinessesList: PropTypes.instanceOf(Function).isRequired,
  addTaxCredit: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  // ordinanceRevisionId: PropTypes.number,
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  updateTaxCredit: PropTypes.instanceOf(Function).isRequired,
  taxCreditData: PropTypes.instanceOf(Object),
  businessId: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.ADD_TAX_CREDIT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(TaxCreditModal);
